import ProgressBar from "./ProgressBar";

export default ProgressBar;



// WEBPACK FOOTER //
// ./src/shared/components/ProgressBar/index.js